import {TransactionsApi} from "@/services/api/TransactionsApi";

export class PositionTransactionsApi extends TransactionsApi {
    public relativeUri: string = "position-transactions";
}
